import { DatePicker } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { useEffect, useRef } from "react";

export type DatePickerProps = {
    min?: Dayjs;
    onChange: Function;
    value?: Date | null;
};


export const SFDatePicker = (props: DatePickerProps) => {
    const datepickerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const inputElement = datepickerRef.current?.querySelectorAll<HTMLInputElement>("input");
        if (inputElement) {
            const inputEl = inputElement[0];

            const handleManualInput = (e: React.ChangeEvent<HTMLInputElement>) => {
                const rawValue = e.target.value.replace(/[^0-9/.]/g, ""); // Allow only valid characters
                const parsedDate = dayjs(rawValue, SUPPORTED_FORMATS, true);
                if (parsedDate.isValid()) {
                    props.onChange && props.onChange(parsedDate);
                }
            };

            // Attach listeners
            inputEl.addEventListener("input", (e: any) => handleManualInput(e));

            return () => {
                inputEl.removeEventListener("input", (e: any) => handleManualInput(e));
            };
        }
    }, [props]);


    const SUPPORTED_FORMATS = [
        "DD/MM/YYYY",
        "DD.MM.YYYY",
        "DD,MM,YYYY",
        "DDMMYYYY"
    ];

    const handleDateChange = (date: Dayjs, dateString: string | string[]) => {
        if (date) {
            props.onChange && props.onChange(date);
        }
        else {
            props.onChange && props.onChange(undefined);
        }
    };

    return (
        <div ref={datepickerRef}>
            <DatePicker
                style={{ width: "100%" }}
                value={
                    props.value
                        ? dayjs(props.value)
                        : null
                }
                format={"DD.MM.YYYY"}
                minDate={props.min}
                onChange={handleDateChange}
            />
        </div>
    );
};